export default __webpack_public_path__ + "static/media/home_icon.6c4ca9a3.svg";